import { useRouter } from "next/router";
import { useEffect, useState } from "react";

interface Params {
  productModel: string | undefined;
  productBrand?: string;
  distributorCode: string;
}

export const flixMediaObject = {
  availableBrands: ["LG", "SAMSUNG", "Tramontina"],
  id: "18128",
};

const FlixMedia = ({ productModel, productBrand, distributorCode }: Params) => {
  const router = useRouter();
  const [isFirstRender, setIsFirstRender] = useState<boolean>(true);

  useEffect(() => {
    let scriptElement: HTMLScriptElement;
    const [headID] = Array.from(document.getElementsByTagName("head"));

    if (isFirstRender) {
      scriptElement = document.createElement("script");
      scriptElement.type = "text/javascript";
      scriptElement.async = true;

      if (flixMediaObject.availableBrands.includes(productBrand || "")) {
        // Lógica para Tramontina
        if (productBrand === "Tramontina") {
          const flexMediaContent = document.querySelector(
            ".flix-media-content"
          );

          const tramontinaContent =
            document.createElement("tramontina-content");

          tramontinaContent.setAttribute("data-id", "178");
          tramontinaContent.setAttribute("data-ref-code", String(productModel));
          tramontinaContent.setAttribute(
            "data-testid",
            `${productBrand.toLowerCase()}-content`
          );

          flexMediaContent?.appendChild(tramontinaContent);

          scriptElement.src =
            "https://ce.tramontina.com/dist/tramontina-content.js";
        }
        // Lógica para Samsung
        else {
          scriptElement.setAttribute("data-flix-distributor", distributorCode);
          scriptElement.setAttribute("data-flix-language", "br");
          scriptElement.setAttribute("data-flix-fallback-language", "");
          scriptElement.setAttribute("data-flix-brand", productBrand || "");
          scriptElement.setAttribute("data-flix-ean", "");
          scriptElement.setAttribute("data-flix-mpn", String(productModel));
          scriptElement.setAttribute("data-flix-inpage", "flix-inpage");
          scriptElement.setAttribute("data-flix-price", "");
          scriptElement.src = "//media.flixfacts.com/js/loader.js";
        }
      }

      headID.appendChild(scriptElement);
      setIsFirstRender(false);

      return undefined;
    }

    const removeHeadChild = () => {
      if (router?.pathname !== "/produto/[idProduct]/[nameProduct]") {
        headID.removeChild(scriptElement);
      }
    };

    router?.events?.on("routeChangeStart", removeHeadChild);

    return () => {
      router?.events?.off("routeChangeStart", removeHeadChild);
    };
  }, [
    distributorCode,
    isFirstRender,
    productBrand,
    productModel,
    router?.events,
    router?.pathname,
  ]);

  return (
    <div className="flix-media-content">
      {(productBrand?.toLowerCase() === "samsung" ||
        productBrand?.toLowerCase() === "lg") && (
        <div
          id="ContentFlixMedia"
          data-testid={`${productBrand.toLowerCase()}-content`}
        >
          <div id="flix-inpage" data-testid="flix-inpage" />
        </div>
      )}
    </div>
  );
};

export default FlixMedia;
